import React, { useMemo } from 'react'

import { getFileIcon, getFileType, getUuid } from 'tyan/public'
import { genFileSizeDesc } from 'tyan/public'
import { useInstData } from 'tyan/public/hooks'
import { genFileText } from '.'
import NewFile from './NewFile'
import Handle from './Handle'
import mimeTypes from 'mime-types'

const AddFiles = ({
	disabled, disableUpload, imageSize, param, valuesCount: valuesCountProp, remain: remainProp,
	accept, unacceptableFiles: unacceptableFilesProps, maxSize: maxSizeProps,
	required: requiredProp, onAddValue,
	enableCapture, editNewImage, enableJoyusingV1
}) => {
	const { me, me: { files, newFiles, appending }, setState } = useInstData(null, () => ({
		files: {}, newFiles: [], appending: []
	}))

	const { acceptExt, acceptType, unacceptableFiles, maxSize } = useMemo(() => {
		const acceptList = accept && accept.toLowerCase().split(',') || []
		let acceptExt = [], acceptType = []
		acceptList.forEach(o => o.startsWith('.') ? acceptExt.push(o.trim()) : o.indexOf('/') && acceptType.push(o.trim().replace('*', '')))

		!acceptExt.length && !acceptType.length && acceptType.push('')

		const unacceptableFiles = unacceptableFilesProps || Tyan.sysConfig.files.unacceptableFiles || []
		const maxSize = maxSizeProps || Tyan.sysConfig.files.maxSize || Infinity

		return { unacceptableFiles, maxSize, acceptExt, acceptType }
	}, [accept, unacceptableFilesProps, maxSizeProps])

	const remain = remainProp - Object.keys(files).length
	const valuesCount = valuesCountProp + Object.keys(files).length
	const required = requiredProp && !Object.keys(files).length

	const handleFileUploaded = (id, FID) => {
		const file = files[id]
		if (!file) return
		const value = {
			FID:/*文件编号*/ FID,
			FileName: /*文件名称*/ file.FileName,
			FileExt: /*文件扩展*/ file.FileExt,
			FileSize: /*文件大小*/ file.FileSize,
			Text: /* 呈现文本 */ file.Text,
		}
		onAddValue(value)
		handleRemoveFile(id)
	}

	const handleAddFiles = fileList => {
		// 将newFiles全部加入到待上传列表
		const handleNewFiles = () => {
			let file
			while (file = newFiles.shift()) files[file.id] = file
			setState({})
		}
		// 编辑图片
		const doEditNewImage = fileParam => {
			const { blob, ...file } = fileParam
			const onSave = blob => {
				newFiles.push({
					...file,
					FileExt: '.jpg',
					FileSize: blob.size,
					type: 'image/jpeg',
					blob: new File([blob], `${file.FileName}.jpg`, { type: 'image/jpeg' })
				})
				setTimeout(handleAppending)
			}

			const onCancel = v => {
				setTimeout(handleAppending)
			}

			Tyan.pubForm.showImageEditor({ url: URL.createObjectURL(blob), needRevoke: true, onSave, onCancel })
		}

		// 处理appending列表，逐个递归处理
		const handleAppending = () => {
			const file = appending.shift()
			// appending为空, 处理newFiles列表
			if (!file) {
				setTimeout(handleNewFiles)
				return
			}

			// 20240309 增加粘贴文件处理
			// 如果 有filePath 并且是是图片类型的话，在imageSize或editNewImage的情况下，将文件内容直接读入生成blob
			const promise = file.filePath && getFileType(getFileIcon(file.FileExt)) === 'Image' && (imageSize || editNewImage)
				? new Promise((resolve, reject) => {
					Tyan.wsFrontEditor.ReadFileData({ fileName: file.filePath, offset: 0, size: file.FileSize }, ({ ret: data }) => {
						if (data) {
							const byteCharacters = atob(data);
							const byteArrays = [];

							for (let i = 0; i < byteCharacters.length; i++) {
								byteArrays.push(byteCharacters.charCodeAt(i))
							}

							const byteArray = new Uint8Array(byteArrays)

							// file.blob = new Blob([byteArray]/* , { type: 'image/jpeg' } *//* , { type: `image/${fileExt}` } */)
							// const file = new File([blob], fileName, { type: "image/jpeg" })
							file.blob = new File(
								[new Blob([byteArray])],
								`${file.FileName}${file.FileExt}`,
								{ type: file.type || mimeTypes.lookup(file.FileExt) }
							)
							// console.log('mimetype:', mimeTypes.lookup(file.FileExt))
							// console.log('debug:', { ...file })
							delete file.filePath
							resolve(file)
						} else {
							reject(`读取文件 ${filePath} 失败`)
						}
					})
				})
				: Promise.resolve(file)

			promise
				.then(file => {
					// 如果没有editNewImage参数或不是图片，则直接加到newFiles中
					if (!editNewImage || getFileType(getFileIcon(file.FileExt)) !== 'Image') {
						newFiles.push(file)
						setTimeout(handleAppending)
						return
					}

					doEditNewImage(file)
				})
				.catch(err => Tyan.pubForm.showPrompt(err))

		}

		let count = Math.min(fileList.length, remain)

		// 将所有文件置于appending中
		// 处理appending列表
		const promises = []
		for (let f of fileList) {
			if (count <= 0) {
				Tyan.pubForm.showPrompt('只能上传 ${remain} 个文件')
				break
			}

			promises.push(new Promise(resolve => {
				let file = { id: getUuid() }, fileName

				if (typeof f === 'string') {
					fileName = f.split('\\').pop()
					file.type = mimeTypes.lookup(fileName) || 'application/octet-stream'
					file.filePath = f
				} else {
					fileName = f.name
					file = {
						...file, ...{
							FileSize: f.size,
							type: f.type,
							blob: f,
						}
					}
				}

				file = {
					...file,
					...{
						FileName: fileName.lastIndexOf('.') < 0 ? fileName : fileName.slice(0, fileName.lastIndexOf('.')),
						FileExt: fileName.lastIndexOf('.') < 0 ? '' : fileName.slice(fileName.lastIndexOf('.')).toLowerCase(),
					}
				};

				// 如果有file.filePath则读取filePath文件大小后再继续
				const prmSize = file.filePath
					? new Promise((resolve, reject) => {
						Tyan.wsFrontEditor.GetFileSize({ filePath: file.filePath }, ({ ret }) => {
							ret ? resolve(file.FileSize = parseInt(ret)) : reject('获取文件大小失败')
						})
					})
					: Promise.resolve()

				prmSize
					.then(() => {
						if (file.FileSize <= 0) throw `文件 ${file.FileName}.${file.FileExt} 为空，不能上传`

						file.Text = genFileText(file.FileName, file.FileExt, file.FileSize)

						// 检查文件后缀是否在unaccepetableFiles中及是否符合accept, 如有不符合条件的文件则直接中断处理
						unacceptableFiles.forEach(o => {
							if (file.FileExt === o)
								throw `不可上传如下类型的文件 ${unacceptableFiles.join(', ')}`
						})

						if (acceptExt.indexOf(file.FileExt) < 0 && acceptType.findIndex(o => file.type.startsWith(o)) < 0)
							throw `不可上传文件 ${file.FileName + file.FileExt}`

						// 检查文件大小
						// maxSize
						if (file.FileSize > maxSize)
							throw `文件 ${blob.name} 大小超出上传限制 ${genFileSizeDesc(maxSize)}`

						// files[id] = file
						count--
						appending.push(file)
						resolve()
					})
					.catch(err => { resolve(); Tyan.pubForm.showPrompt(err) })
			}))
		}

		Promise.allSettled(promises).then(vs => {
			// console.log('vs:', vs, appending)
			handleAppending()
		})
	}

	const handleRemoveFile = id => {
		delete files[id]
		setState({})
	}

	return <>
		{Object.entries(files).map(([id, file]) => <NewFile key={id} {...{ file, imageSize, param, onFileUploaded: handleFileUploaded, onRemoveFile: handleRemoveFile }} />)}
		{!disabled && !disableUpload && remain
			? <Handle {...{ imageSize, valuesCount, required, remain, onAddFiles: handleAddFiles, accept, enableCapture, enableJoyusingV1 }} />
			: null
		}
	</>
}

export default AddFiles